module.exports = __webpack_public_path__ + "img/topLogo.ba4e3bf5.png";